/**
 * Last-resort body for tenant marketing pages whose HTML couldn't be structured
 * into cards. Renders the original page HTML in a styled, dark-aware prose
 * column — still a clear step up from the old bare `max-w-3xl` render, and
 * wrapped by the page's hero + CTA band for visual consistency.
 */
export default function ProseFallback({ html }: { html: string }) {
  return (
    <section className="bg-surface">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <div
          className="prose prose-stone dark:prose-invert max-w-none prose-headings:font-display prose-headings:text-sage-900 prose-a:text-sage-700 prose-strong:text-sage-900 prose-img:rounded-xl"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </section>
  );
}
